import React, { useState } from "react";
import {
  CheckCircle,
  Users,
  Clock,
  Globe,
  Star,
  ArrowRight,
  Mail,
  Phone,
} from "lucide-react";
import triosoft from "../assets/triosoft.png";
import {
  server_post_data,
  quote_save_triosoft,
} from "../ServiceConnection/serviceconnection.js";
import {
  check_vaild_save,
  combiled_form_data,
  getRandomSixLetterString,
  empty_form,
  handleLinkClick,
} from "../CommonJquery/CommonJquery.js";
import { useEffect } from "react";
let captch_check = "";
const TriosoftLanding = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [userInputCpt, setUserInputCpt] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(true);

  const [showThankYou, setShowThankYou] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    handleSaveChangesdynamic("CarrerformData", quote_save_triosoft);

    // Simulate form submission
  };

  useEffect(() => {
    if (captch_check === "") {
      captch_check = getRandomSixLetterString();
    }
  }, [captch_check]);

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      if (userInputCpt === captch_check) {
        setShowLoader(true);
        setIsSubmitting(true);
        setIsCaptchaValid(true);
        let fd_from = combiled_form_data(form_data, null);
        await server_post_data(url_for_save, fd_from)
          .then((Response) => {
            setShowLoader(false);
            empty_form(form_data);
            captch_check = getRandomSixLetterString();
            setIsSubmitting(false);
            setShowThankYou(true);
            setTimeout(() => {
              setIsSubmitting(false);
              setShowThankYou(false);
            }, 3000);
          })
          .catch((error) => {
            setShowLoader(false);
            console.log(error.message);
          });
      } else {
        setIsCaptchaValid(false);
      }
    }
  };

  const scrollToForm = () => {
    document.getElementById("lead-form").scrollIntoView({ behavior: "smooth" });
  };

  if (showThankYou) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <div
          style={{
            background: "white",
            padding: "60px 40px",
            borderRadius: "20px",
            textAlign: "center",
            maxWidth: "500px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
          }}
        >
          <div style={{ marginBottom: "20px" }}>
            <CheckCircle size={64} style={{ color: "#10B981" }} />
          </div>
          <h2
            style={{
              fontSize: "28px",
              color: "#1a202c",
              marginBottom: "16px",
              fontWeight: "700",
            }}
          >
            Thank You!
          </h2>
          <p
            style={{
              fontSize: "18px",
              color: "#718096",
              marginBottom: "30px",
              lineHeight: "1.6",
            }}
          >
            We'll connect with you within 12-24 hours. You can also WhatsApp us
            now for immediate assistance.
          </p>
          <a
            href="https://wa.me/+917880016644"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "#25D366",
              color: "white",
              padding: "12px 24px",
              borderRadius: "25px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "16px",
              transition: "transform 0.2s ease",
            }}
          >
            <Phone size={20} />
            WhatsApp Us Now
          </a>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
        lineHeight: "1.6",
        color: "#2d3748",
      }}
    >
      {/* Header */}
      <header
        style={{
          background: "white",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          zIndex: "1000",
          padding: "10px 0",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <img
            src={triosoft}
            onClick={() => handleLinkClick("/")}
            alt="Triosoft Technologies"
            style={{
              height: window.innerWidth <= 768 ? "35px" : "50px",
              cursor: "pointer",
            }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: window.innerWidth <= 768 ? "10px" : "20px",
              flexWrap: "wrap",
            }}
          >
            <button
              onClick={scrollToForm}
              style={{
                background: "linear-gradient(135deg, #1e40af 0%, #0ea5e9 100%)",
                color: "white",
                border: "none",
                padding: window.innerWidth <= 768 ? "8px 16px" : "10px 20px",
                borderRadius: "25px",
                fontWeight: "600",
                cursor: "pointer",
                fontSize: window.innerWidth <= 768 ? "12px" : "14px",
              }}
            >
              Get Started
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section
        style={{
          background: "linear-gradient(135deg, #1e40af 0%, #0ea5e9 100%)",
          color: "white",
          padding:
            window.innerWidth <= 768 ? "100px 15px 60px" : "120px 20px 80px",
          marginTop: window.innerWidth <= 768 ? "60px" : "80px",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: window.innerWidth <= 768 ? "block" : "grid",
            gridTemplateColumns: window.innerWidth <= 768 ? "1fr" : "1fr 1fr",
            gap: window.innerWidth <= 768 ? "40px" : "60px",
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                background: "rgba(255,255,255,0.2)",
                padding: "8px 16px",
                borderRadius: "20px",
                marginBottom: "24px",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              <Globe size={16} />
              Trusted by 50+ Countries
            </div>

            <h1
              style={{
                fontSize:
                  window.innerWidth <= 768
                    ? window.innerWidth <= 480
                      ? "28px"
                      : "36px"
                    : "48px",
                fontWeight: "800",
                lineHeight: "1.2",
                marginBottom: "24px",
                background: "linear-gradient(135deg, #fff 0%, #e2e8f0 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: window.innerWidth <= 768 ? "center" : "left",
              }}
            >
              Hire Skilled Software Developers from India
            </h1>

            <p
              style={{
                fontSize: window.innerWidth <= 768 ? "16px" : "20px",
                marginBottom: "32px",
                opacity: "0.9",
                lineHeight: "1.6",
                textAlign: window.innerWidth <= 768 ? "center" : "left",
              }}
            >
              Powered by <strong>Triosoft Technologies Pvt. Ltd.</strong>, we
              help businesses worldwide hire top developers in 24–48 hours.
            </p>

            <button
              onClick={scrollToForm}
              style={{
                background: "white",
                color: "#1e40af",
                border: "none",
                padding: "16px 32px",
                borderRadius: "30px",
                fontSize: "18px",
                fontWeight: "700",
                marginBottom: "15px",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                transition: "transform 0.2s ease",
              }}
              onMouseOver={(e) =>
                (e.target.style.transform = "translateY(-2px)")
              }
              onMouseOut={(e) => (e.target.style.transform = "translateY(0)")}
            >
              Get Developers Now
              <ArrowRight size={20} />
            </button>
          </div>

          <div
            style={{
              textAlign: "center",
              order: window.innerWidth <= 768 ? "-1" : "0",
            }}
          >
            <div
              style={{
                background: "rgba(255,255,255,0.1)",
                borderRadius: "20px",
                padding: "40px",
                backdropFilter: "blur(10px)",
              }}
            >
              <Users
                size={80}
                style={{
                  marginBottom: "20px",
                  opacity: "0.8",
                  placeSelf: window.innerWidth <= 768 ? "center" : "auto",
                }}
              />
              <h3
                style={{
                  fontSize: "24px",
                  marginBottom: "16px",
                  fontWeight: "700",
                }}
              >
                Remote Development Team
              </h3>
              <p style={{ opacity: "0.8", fontSize: "16px" }}>
                Expert developers ready to join your team and deliver
                exceptional results
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section
        style={{
          padding: window.innerWidth <= 768 ? "60px 15px" : "80px 20px",
          background: "#f8fafc",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            style={{
              textAlign: "center",
              marginBottom: window.innerWidth <= 768 ? "40px" : "60px",
            }}
          >
            <h2
              style={{
                fontSize:
                  window.innerWidth <= 768
                    ? window.innerWidth <= 480
                      ? "24px"
                      : "28px"
                    : "36px",
                fontWeight: "800",
                color: "#1a202c",
                marginBottom: "16px",
              }}
            >
              Why Choose Triosoft for Hiring Developers?
            </h2>
            <p
              style={{
                fontSize: window.innerWidth <= 768 ? "16px" : "18px",
                color: "#718096",
                maxWidth: "600px",
                margin: "0 auto",
              }}
            >
              We connect you with India's finest software talent, trusted by
              companies worldwide
            </p>
          </div>

          <div
            style={{
              display: window.innerWidth <= 768 ? "flex" : "grid",
              gridTemplateColumns:
                window.innerWidth <= 768
                  ? "none"
                  : "repeat(auto-fit, minmax(280px, 1fr))",
              gap: window.innerWidth <= 768 ? "15px" : "40px",
              overflowX: window.innerWidth <= 768 ? "auto" : "visible",
              paddingBottom: window.innerWidth <= 768 ? "20px" : "0",
              scrollbarWidth: "thin",
              WebkitOverflowScrolling: "touch",
            }}
          >
            {[
              {
                icon: (
                  <CheckCircle
                    size={48}
                    style={{
                      color: "#10B981",
                      placeSelf: window.innerWidth <= 768 ? "center" : "auto",
                    }}
                  />
                ),
                title: "Pre-vetted Talent",
                description:
                  "Skilled developers across web, mobile, AI, cloud, and DevOps with proven track records.",
              },
              {
                icon: (
                  <Star
                    size={48}
                    style={{
                      color: "#F59E0B",
                      placeSelf: window.innerWidth <= 768 ? "center" : "auto",
                    }}
                  />
                ),
                title: "Cost Advantage",
                description:
                  "Save up to 50% with India's best offshore talent without compromising on quality.",
              },
              {
                icon: (
                  <Clock
                    size={48}
                    style={{
                      color: "#8B5CF6",
                      placeSelf: window.innerWidth <= 768 ? "center" : "auto",
                    }}
                  />
                ),
                title: "Fast Onboarding",
                description:
                  "Get your development team ready and start working in just 24–48 hours.",
              },
              {
                icon: (
                  <Globe
                    size={48}
                    style={{
                      color: "#3B82F6",
                      placeSelf: window.innerWidth <= 768 ? "center" : "auto",
                    }}
                  />
                ),
                title: "Global Experience",
                description:
                  "Trusted by 200+ companies across USA, UK, EU & Asia with proven success stories.",
              },
            ].map((benefit, index) => (
              <div
                key={index}
                style={{
                  background: "white",
                  padding: window.innerWidth <= 768 ? "30px 20px" : "40px 30px",
                  borderRadius: "15px",
                  textAlign: "center",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s ease",
                  minWidth: window.innerWidth <= 768 ? "250px" : "auto",
                  display: window.innerWidth <= 768 ? "inline-block" : "block",
                  marginRight: window.innerWidth <= 768 ? "15px" : "0",
                  verticalAlign: "top",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "translateY(-5px)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                <div style={{ marginBottom: "20px" }}>{benefit.icon}</div>
                <h3
                  style={{
                    fontSize: window.innerWidth <= 768 ? "18px" : "22px",
                    fontWeight: "700",
                    color: "#1a202c",
                    marginBottom: "16px",
                  }}
                >
                  {benefit.title}
                </h3>
                <p
                  style={{
                    color: "#718096",
                    fontSize: window.innerWidth <= 768 ? "14px" : "16px",
                    lineHeight: "1.6",
                  }}
                >
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust & Credibility Section */}
      <section
        style={{
          padding: window.innerWidth <= 768 ? "60px 15px" : "80px 20px",
          background: "white",
        }}
      >
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}
        >
          <img
            src={triosoft}
            alt="Triosoft Technologies"
            style={{
              height: window.innerWidth <= 768 ? "40px" : "60px",
              placeSelf: window.innerWidth <= 768 ? "center" : "auto",
              marginBottom: "24px",
            }}
          />

          <h3
            style={{
              fontSize: window.innerWidth <= 768 ? "20px" : "24px",
              fontWeight: "700",
              color: "#1a202c",
              marginBottom: "16px",
            }}
          >
            Powered by Triosoft Technologies Pvt. Ltd.
          </h3>

          <p
            style={{
              fontSize: window.innerWidth <= 768 ? "16px" : "18px",
              color: "#718096",
              maxWidth: "800px",
              margin: "0 auto 40px",
              lineHeight: "1.6",
              padding: window.innerWidth <= 768 ? "0 10px" : "0",
            }}
          >
            A leading IT development and staff augmentation partner for 200+
            businesses worldwide. We deliver excellence through our carefully
            vetted network of software professionals.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: window.innerWidth <= 768 ? "30px" : "60px",
              flexWrap: "wrap",
              marginBottom: "40px",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  fontSize: window.innerWidth <= 768 ? "28px" : "36px",
                  fontWeight: "800",
                  color: "#1e40af",
                  marginBottom: "8px",
                }}
              >
                200+
              </div>
              <div
                style={{
                  color: "#718096",
                  fontSize: window.innerWidth <= 768 ? "12px" : "14px",
                  fontWeight: "600",
                }}
              >
                HAPPY CLIENTS
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  fontSize: window.innerWidth <= 768 ? "28px" : "36px",
                  fontWeight: "800",
                  color: "#1e40af",
                  marginBottom: "8px",
                }}
              >
                50+
              </div>
              <div
                style={{
                  color: "#718096",
                  fontSize: window.innerWidth <= 768 ? "12px" : "14px",
                  fontWeight: "600",
                }}
              >
                COUNTRIES SERVED
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  fontSize: window.innerWidth <= 768 ? "28px" : "36px",
                  fontWeight: "800",
                  color: "#1e40af",
                  marginBottom: "8px",
                }}
              >
                24-48h
              </div>
              <div
                style={{
                  color: "#718096",
                  fontSize: window.innerWidth <= 768 ? "12px" : "14px",
                  fontWeight: "600",
                }}
              >
                QUICK START
              </div>
            </div>
          </div>

          <div
            style={{
              background: "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)",
              padding: "30px",
              borderRadius: "15px",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            <p
              style={{
                fontSize: "16px",
                fontStyle: "italic",
                color: "#475569",
                marginBottom: "16px",
              }}
            >
              "Triosoft has been instrumental in scaling our development team.
              Their developers are not just skilled, but truly understand our
              business needs."
            </p>
            <div style={{ fontWeight: "600", color: "#1a202c" }}>
              — Sarah Johnson, CTO at Hotify India
            </div>
          </div>
        </div>
      </section>

      {/* Lead Capture Form */}
      <section
        id="lead-form"
        style={{
          padding: window.innerWidth <= 768 ? "60px 15px" : "80px 20px",
          background: "linear-gradient(135deg, #1a202c 0%, #2d3748 100%)",
        }}
      >
        <div
          style={{
            maxWidth: window.innerWidth <= 768 ? "100%" : "600px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: window.innerWidth <= 768 ? "30px" : "40px",
            }}
          >
            <h2
              style={{
                fontSize:
                  window.innerWidth <= 768
                    ? window.innerWidth <= 480
                      ? "24px"
                      : "28px"
                    : "36px",
                fontWeight: "800",
                color: "white",
                marginBottom: "16px",
              }}
            >
              Get Your Development Team Today
            </h2>
            <p
              style={{
                fontSize: window.innerWidth <= 768 ? "16px" : "18px",
                color: "#a0aec0",
                padding: window.innerWidth <= 768 ? "0 10px" : "0",
              }}
            >
              Fill out the form below and we'll connect you with the perfect
              developers within 12-24 hours
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: window.innerWidth <= 768 ? "30px 20px" : "40px",
              borderRadius: "20px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            }}
          >
            <form id="CarrerformData">
              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Full Name *
                </label>
                <input
                  type="text"
                  name="f_name"
                  className="trio_mendate trio_name form-control "
                  id="f_name"
                  required
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "10px",
                    fontSize: "16px",
                    transition: "border-color 0.2s ease",
                    outline: "none",
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(
                      /^\s+|[^A-Za-z\s]/g,
                      ""
                    );
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#1e40af")}
                  onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                />
              </div>

              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Work Email *
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  className="trio_mendate trio_email form-control "
                  required
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "10px",
                    fontSize: "16px",
                    transition: "border-color 0.2s ease",
                    outline: "none",
                  }}
                  onBeforeInput={(e) => {
                    if (!/^[a-zA-Z0-9@.]+$/.test(e.data)) {
                      e.preventDefault(); // prevent invalid character from being typed
                    }
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#1e40af")}
                  onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                />
              </div>

              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Company Name
                </label>
                <input
                  type="text"
                  name="company"
                  id="company"
                  className=" form-control "
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "10px",
                    fontSize: "16px",
                    transition: "border-color 0.2s ease",
                    outline: "none",
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(
                      /^\s+|[^A-Za-z0-9\s]/g,
                      ""
                    );
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#1e40af")}
                  onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                />
              </div>

              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Skills Needed
                </label>
                <select
                  name="platform"
                  id="platform"
                  className=" form-control trio_mendate"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "10px",
                    fontSize: "16px",
                    transition: "border-color 0.2s ease",
                    outline: "none",
                    background: "white",
                    color: "black",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#1e40af")}
                  onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                >
                  <option value="">Select skills needed...</option>
                  <option value="web">Web Development</option>
                  <option value="mobile">Mobile Development</option>
                  <option value="ai-ml">AI/ML Development</option>
                  <option value="cloud">Cloud Development</option>
                  <option value="devops">DevOps</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div style={{ marginBottom: "32px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Project Brief
                </label>
                <textarea
                  name="idea"
                  id="idea"
                  rows="4"
                  className=" form-control trio_mendate"
                  placeholder="Tell us about your project requirements..."
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "10px",
                    fontSize: "16px",
                    transition: "border-color 0.2s ease",
                    outline: "none",
                    resize: "vertical",
                    fontFamily: "inherit",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#1e40af")}
                  onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                />
              </div>
              <div className="inputFormCareer captchadIV col-md-12">
                <div>
                  <div className="captchaText">
                    <label htmlFor="captcha">Enter Captcha</label>

                    <h6 className="captch_select">{captch_check}</h6>
                  </div>
                  <input
                    type="text"
                    className="form-control trio_mendate"
                    id="captcha"
                    name="captcha"
                    onChange={(e) => {
                      setUserInputCpt(e.target.value);
                    }}
                    required
                  />
                  {isCaptchaValid ? (
                    <p></p>
                  ) : (
                    <p className="text-danger mt-1 text-center">
                      Invalid CAPTCHA .
                    </p>
                  )}
                </div>
              </div>
              <button
                onClick={handleSubmit}
                disabled={isSubmitting}
                type="button"
                style={{
                  width: "100%",
                  background: isSubmitting
                    ? "#9ca3af"
                    : "linear-gradient(135deg, #1e40af 0%, #0ea5e9 100%)",
                  color: "white",
                  border: "none",
                  padding: "16px 32px",
                  borderRadius: "12px",
                  fontSize: "18px",
                  fontWeight: "700",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  transition: "transform 0.2s ease",
                }}
                onMouseOver={(e) =>
                  !isSubmitting &&
                  (e.target.style.transform = "translateY(-1px)")
                }
                onMouseOut={(e) => (e.target.style.transform = "translateY(0)")}
              >
                {isSubmitting ? "Submitting..." : "Get Developers Now"}
                {!isSubmitting && <ArrowRight size={20} />}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        style={{
          background: "#1a202c",
          color: "white",
          padding: window.innerWidth <= 768 ? "30px 15px" : "40px 20px",
        }}
      >
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}
        >
          <img
            src={triosoft}
            onClick={() => handleLinkClick("/")}
            alt="Triosoft Technologies"
            style={{
              height: window.innerWidth <= 768 ? "30px" : "40px",
              marginBottom: "20px",
              placeSelf: window.innerWidth <= 768 ? "center" : "auto",
              filter: "brightness(0) invert(1)",
              cursor: "pointer",
            }}
          />

          <p
            style={{
              marginBottom: "16px",
              color: "#a0aec0",
              fontSize: window.innerWidth <= 768 ? "14px" : "16px",
            }}
          >
            © 2025 Triosoft Technologies Pvt. Ltd. All rights reserved.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: window.innerWidth <= 768 ? "20px" : "30px",
              flexWrap: "wrap",
              fontSize: window.innerWidth <= 768 ? "14px" : "16px",
            }}
          >
            <a
              href="mailto:support@triosoft.ai"
              style={{
                color: "#a0aec0",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <Mail size={16} />
              support@triosoft.ai
            </a>
            <a
              href="https://www.triosoft.ai"
              style={{ color: "#a0aec0", textDecoration: "none" }}
            >
              www.triosoft.ai
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TriosoftLanding;
